import { getFeatureFlags } from "src/pageDefinitions/featureFlags";
import { registerMonitorProvider } from "../prop-registry";

registerMonitorProvider("monitoring", () => {
  return {
    featureFlags: getFeatureFlags() as JsonObject,
  };
});
